import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button
} from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import "../../styles/estilos.css";
import Page from "components/Page";
import {Textbox} from "react-inputs-validation";

import { fetchAgregarProductoCarritoAP, fetchCalcularCotizacionAP, resetStateAP } from "../../redux/actions/aRamoAccidentesPersonales";
import { TravelAccidentesPersonales } from "../../constants";


class CotizacionAPersonal2 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      numDias: "",
      hasNumDiasError: true,
      selPlan: false,
      idPlan: ""
    };
    this.onClickRegresar = this.onClickRegresar.bind(this);
    this.validateForm = this.validateForm.bind(this);
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }
  
  async validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      hasNumDiasError
    } = this.state;

    if (
      !hasNumDiasError && this.state.numDias>= TravelAccidentesPersonales.minDias
    ) {


      await this.props.calculoCotizacion({

        "empresa":"AIGMETROPOLITANA",
        "codProducto":this.state.idPlan,
        "numDias":this.state.numDias,
        "idCarrito":this.props.datosCarritoAPTravelGroup.carritoAPTravelGroup['mongoCarrito']
      })
      

     this.props.history.push({
        pathname: "/detalle-cotizacion-accidente",      
      }); 
    }else{
      console.log("NO VALIDO");
    }
  }


  componentDidUpdate(prevProps, prevState) {

    if (prevState.idPlan !== this.state.idPlan) {
          this.guardarProductoCarrito()
  }

}


posiciona(){
  window.scroll(0, 0);
}

  async guardarProductoCarrito(){
    await this.props.agregaProducto({
      "empresa":"AIGMETROPOLITANA",
        "codProd":this.state.idPlan,
        "idCarrito":this.props.datosCarritoAPTravelGroup.carritoAPTravelGroup['mongoCarrito']
    });
  }

  async onClickRegresar(e) {
    this.props.history.replace({
      pathname: `/cotizacion-accidente`,
      search:'?id='+this.props.datosCarritoAPTravelGroup.carritoAPTravelGroup.mongoCarrito
    });
  }

  componentDidMount() {
    window.scroll(0, 0);
    this.props.resetStateAP();
  }

  render() {
    const {selPlan,numDias, validate} = this.state;
    console.log(this.state);

    
        //console.log(this.state);
        let isLoading = this.props.datosCalculosCotizacionAP.calculoCotizacionAPIsLoading === undefined ? false : this.props.datosCalculosCotizacionAP.calculoCotizacionAPIsLoading;
    

    return (




      <LoadingScreen
        loading={isLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Obteniendo datos..."
      >
        
        <Page
         title="Cotización Travel Guard"
        breadcrumbs={[{ name: "Cotización Accidentes", active: true }]}
        >
          <div className="container-step ">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          {!selPlan &&
          
            <Col lg={11} md={12} sm={12} xs={12} className="div-align-center">
              <Row className="menu-superior-pantallas-grandes">
                <Col lg={10} md={12} sm={12} xs={12} className="div-align-center">
                  <Card className="flex-row ">
                    <CardBody>
                      <Col lg={11} md={11} sm={11} xs={11} className="div-align-center">
                          <h3 style={{ fontWeight: "bold", textAlign:"center"}} >PLAN DE VIAJES CORPORATIVOS</h3>
                          <p style={{ fontWeight: "300", textAlign:"center"}} >A continuación se detalla  una tabla comparativa de las coberturas y beneficios de nuestros productos para su selección</p>                     
                      </Col>
                      <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                      <Row className="mb-2"> 
                        <Col lg={5}md={5}sm={5}xs={5}  className="div-align-center"  style={{backgroundColor: "#a8a8aa"} }>
                            <h2 style={{ fontWeight: "large", color:"#001871", textAlign:"center"}} >COBERTURA Y BENEFICIOS</h2>      
                        </Col>   
                        {this.props.datosCoberturasAP.primas !== undefined 
                        && this.props.datosCoberturasAP.primas.map(prima => {
                          return (
                            <Col lg={3} md={3} sm={3} xs={3} className="div-align-center"  style={{backgroundColor: `${prima.aspecto[0].fondo}`} }>
                              <h2 style={{fontWeight: "large", color:`${prima.aspecto[0].letra}`, textAlign:"center",textTransform: "uppercase"}}>{prima.nomProducto}</h2>      
                            </Col>   
                            );
                          })
                          }
                      </Row>
                      {this.props.datosCoberturasAP.coberturas !== undefined
                        && this.props.datosCoberturasAP.coberturas.map(cobertura => {
                          let tamfuente ="large";
                          let margen="0px 0px 0px 0px";
                          if(cobertura.padre!=="")
                          {
                            tamfuente ="100";
                            margen="0px 0px 0px 20px";
                          }
                          let content = "";
                          let valValores= true;
                          if(cobertura.valores.length>0){
                            content = cobertura.valores.map((val) =>
                              <Col lg={3} md={3} sm={3} xs={3} className="div-align-center"  style={{backgroundColor: "#d1d0ce"} }>
                              <p style={{ fontWeight: "large", textAlign:"center"}}>{val.valor}</p>      
                              </Col>
                            );
                          }else{
                            valValores=false;
                          }
                          
                          return (
                                <Row className="mb-2"> 
                                    <Col lg={5} md={5} sm={5} xs={5} className="div-align-center"  style={{backgroundColor: "#d1d0ce"} }>
                                        <p style={{ fontWeight: `${tamfuente}`, padding: `${margen}`}} >{cobertura.nomCober}</p>      
                                    </Col> 
                                    {!valValores &&
                                        <Col lg={3} md={3} sm={3} xs={3} className="div-align-center"  style={{backgroundColor: "#d1d0ce"} }>
                                          <p>{" "}</p>      
                                        </Col> 
                                    }  
                                    {!valValores &&
                                        <Col lg={3} md={3} sm={3} xs={3} className="div-align-center"  style={{backgroundColor: "#d1d0ce"} }>
                                          <p>{" "}</p>      
                                        </Col> 
                                    }  
                                    {content}
                                </Row>
                            );                     
                        })
                        }
                      <Row> 
                        <Col lg={5}md={5}sm={5}xs={5}className="div-align-center">
                        </Col>   
                        {this.props.datosCoberturasAP.primas !== undefined 
                        && this.props.datosCoberturasAP.primas.map(prima => {
                          return (
                            <Col lg={3} md={3} sm={3} xs={3} className="div-align-center"  style={{backgroundColor: `${prima.aspecto[0].fondo}`} }>
                              <h2 style={{fontWeight: "large", color:`${prima.aspecto[0].letra}`, textAlign:"center",textTransform: "uppercase"}}>{prima.nomProducto}</h2>      
                            </Col>   
                            );
                          })
                        }
                      </Row>
                      <Row className="mb-2"> 
                        <Col lg={5}md={5}sm={5}xs={5} className="div-align-center"  style={{backgroundColor: "#a8a8aa"} }>
                            <h3 style={{ fontWeight: "normal"}} >PRIMA TOTAL POR DÍA</h3>      
                        </Col>   
                        {this.props.datosCoberturasAP.primas !== undefined 
                        && this.props.datosCoberturasAP.primas.map(prima => {
                          return (
                            <Col lg={3} md={3} sm={3} xs={3} className="div-align-center"  style={{backgroundColor: "#a8a8aa"} }>
                              <h2 style={{fontWeight: "bold", color:"#af006e", textAlign:"center",textTransform: "uppercase"}}>${prima.primaDia}</h2>    
                            </Col>
                            );
                          })
                          }
                      </Row>               
                      <Row className="mb-5"> 
                        <Col lg={5} md={5} sm={5} xs={5} className="div-align-center" >
                                <Button
                                    className="btn btn-detail-gray"
                                    onClick={this.onClickRegresar}
                                >
                                <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                                {"REGRESAR"}
                                </Button>  
                        </Col>   
                        {this.props.datosCoberturasAP.primas !== undefined 
                        && this.props.datosCoberturasAP.primas.map(prima => {
                          return (
                            <Col lg={3} md={3} sm={3} xs={3} className="div-align-center" >
                                <Button
                                    className="btn btn-primary"
                                    onClick={
                                      () => this.setState({ selPlan: true, idPlan:prima.codProducto}, this.posiciona)                                    
                                    }
                                    style={{ display: "block", margin: "auto" }}
                                >
                                <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                                {"SELECCIONAR"}
                                </Button>                    
                            </Col>   
                            );
                          })
                          }
                      </Row>       
                    </Col>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row className="menu-superior-pantallas-pequenas">
                <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                  <Card className="flex-row ">
                    <CardBody>
                      <Row className="mb-3">
                        <Col lg={11} md={11} sm={11} xs={11} className="div-align-center">
                            <h3 style={{ fontWeight: "bold", textAlign:"center"}} >PLAN DE VIAJES CORPORATIVOS</h3>
                            <p style={{ fontWeight: "300", textAlign:"center"}} >A continuación se detalla  una tabla comparativa de las coberturas y beneficios de nuestros productos para su selección</p>                     
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Row className="mb-2"> 
                            <Col  lg={12} md={12} sm={12} xs={12}>
                              <Col lg={10}md={10}sm={10}xs={10} className="div-align-center" style={{backgroundColor: "#a8a8aa"} }>
                                <h2 style={{ fontWeight: "large", color:"#001871", textAlign:"center"}} >COBERTURA Y BENEFICIOS</h2>      
                              </Col>
                            </Col>
                          </Row>
                          {this.props.datosCoberturasAP.coberturas !== undefined
                          && this.props.datosCoberturasAP.coberturas.map(cobertura => {
                            let tamfuente ="large";
                            let margen="0px 0px 0px 0px";
                            if(cobertura.padre!=="")
                            {
                              tamfuente ="100";
                              margen="0px 0px 0px 20px";
                            }
                            let content2 ="";
                            if(cobertura.valores.length>0){
                              content2 = cobertura.valores.map((val) =>
                                <Col  lg={12} md={12} sm={12} xs={12} style={{marginBottom: "0px"} } >
                                  <Col lg={10} md={10} sm={10} xs={10} className="div-align-center" style={{backgroundColor: `${val.nombreColor[0].fondo}`} }>
                                    <h2 style={{fontWeight: "large", color:`${val.nombreColor[0].letra}`, textAlign:"center", textTransform: "uppercase"}}>{val.nomProducto}</h2>      
                                  </Col>                                   
                                  <Col lg={10} md={10} sm={10} xs={10} className="div-align-center" style={{backgroundColor: "#d1d0ce"}}>
                                    <p style={{ fontWeight: "large", textAlign:"center"}}>{val.valor}</p>      
                                  </Col>
                                </Col>
                              );
                            }
                            return (
                                  <Row className="mb-3">
                                      <Col  lg={12} md={12} sm={12} xs={12} style={{marginBottom: "0px"} } >
                                        <Col lg={10} md={10} sm={10} xs={10} className="div-align-center" style={{backgroundColor: "#a8a8aa", marginBottom: "0px"} }>
                                          <p style={{ color:"#af006e", fontWeight: `${tamfuente}`, padding: `${margen}`}} >{cobertura.nomCober}</p>      
                                        </Col>   
                                      </Col>   
                                      {content2}
                                  </Row>
                              );
                          })
                          }
                          <Row className="mt-5"> 
                            <Col  lg={12} md={12} sm={12} xs={12}>
                              <Col lg={10} md={10} sm={10} xs={10} className="div-align-center"  style={{backgroundColor: "#a8a8aa"} }>
                                <h3 style={{ fontWeight: "normal"}} >PRIMA TOTAL POR DÍA</h3>      
                              </Col>   
                            </Col>                        
                          </Row>                        
                          {Object.keys(this.props.datosCoberturasAP).length > 0 
                          && this.props.datosCoberturasAP.primas.map(prima => {
                            return (
                              <Row>
                                <Col  lg={12} md={12} sm={12} xs={12} style={{marginBottom: "0px"} } >
                                  <Col lg={10} md={10} sm={10} xs={10} className="div-align-center"  style={{backgroundColor: `${prima.aspecto[0].fondo}`} }>
                                    <h2 style={{fontWeight: "large", color:`${prima.aspecto[0].letra}`, textAlign:"center",textTransform: "uppercase"}}>{prima.nomProducto}</h2>      
                                  </Col>   
                                  <Col lg={10} md={10} sm={10} xs={10} className="div-align-center"  style={{backgroundColor: "#d1d0ce"} }>
                                    <h2 style={{fontWeight: "bold", color:"#af006e", textAlign:"center",textTransform: "uppercase"}}>${prima.primaDia}</h2>    
                                  </Col>                                
                                  <Col lg={10} md={10} sm={10} xs={10} className="div-align-center" >
                                    <Button
                                        className="btn btn-primary"
                                        onClick={() => this.setState({ selPlan: true, idPlan:prima.codProducto})}
                                        style={{ display: "block", margin: "auto" }}
                                    >
                                    <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                                    {"SELECCIONAR"}
                                    </Button>                    
                                  </Col>  
                                </Col>    
                              </Row>                        
                              );
                            })
                          }
                          <Row className="mt-3"> 
                            <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                              <Button
                                  className="btn btn-detail-gray"
                                  onClick={this.onClickRegresar}
                                  style={{ display: "block", margin: "auto" }}
                              >
                              <i className="fa fa-chevron-circle-left" aria-hidden="true" />{" REGRESAR"}
                              </Button>  
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>                         
              </Row>
              <Row>
                  <Col lg={10} md={10}sm={12} xs={12} className="div-align-center">
                    <Card className="flex-row ">
                      <CardBody>
                        <Row style={{margin:"3px"}}>
                            <h5 style={{fontWeight: "large"}}>Nota: Los limites expuestos se enecuentran en dólares americanos. Las primas antes mencionadas incluyen impuestos  de ley.</h5>
                        </Row>
                    </CardBody>
                  </Card>
                  </Col>
              </Row>  
          </Col>
        }
        {selPlan &&
          <Col lg={8} md={12} sm={12} xs={12} className="div-align-center">
            <Row>
              <Col lg={10} md={10}sm={12} xs={12} className="div-align-center">
                <Card className="flex-row ">
                  <CardBody>
                    <h4 style={{ fontWeight: "bold" }} className='mb-5'> PLAN DE VIAJES CORPORATIVOS</h4>
                    <Col lg={9} md={12}sm={12} xs={12} className="div-align-center">
                      <Row>
                        <Col lg={7} md={7} sm={12} xs={12}>
                          <h4 style={{ fontWeight: "large" }} >Número de días que desea contratar </h4>   
                            <p style={{ fontWeight: "100"}} >Mínimo de dias a contratar {TravelAccidentesPersonales.minDias}</p>
                        </Col>
                        <Col  lg={5} md={5} sm={12} xs={12}>
                          <Col  lg={11} md={11} sm={12} xs={12}>
                               

                                <Textbox
                                  tabIndex="0" // Optional.[String or Number].Default: none.
                                  id='numDias'// Optional.[String].Default: "".  Input ID.
                                  name="numDias" // Optional.[String].Default: "". Input name.
                                  type="text" // Optional.[String].Default: "text". Input type [text, password, number]. NOTE: provide "text" for better performance since different browsers run differently with "number".
                                  value={numDias} // Optional.[String].Default: "".
                                  placeholder={`Mímimo ${TravelAccidentesPersonales.minDias} días`} // Optional.[String].Default: "".
                     
                                  onChange={(numDias, e) => {
                                    let numerDias=numDias===''?'' : parseInt(numDias)
                                    this.setState({ 
                                        numDias:numerDias,
                                        hasNumDiasError:false 
                                    });                   
                                }}


                                  onBlur={e => {
                                    this.setState({ blur: true });
                                    //console.log("BLUUUR");
                                  }} 
  
                                  validate={validate}
                                  validationCallback={res => {
                                      this.setState({
                                        hasNumDiasError: res,
                                          validate: !res
                                      })
                                    }
                                  }

                                  validationOption={{
                                   
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true,
                                    type: 'number', // Optional.[String].Default: "string". Validation type, options are ['string', 'number', 'alphanumeric', 'alpha'].
                                    min: TravelAccidentesPersonales.minDias, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
                                    //reg: /^[0-9]+$/, //Optional.[Bool].Default: "" Custom regex.
                                    //regMsg:"Por favor ingrese solo carácteres númericos",
                                    msgOnError: `Ingrese solo caráteres númericos y un mínimo de ${TravelAccidentesPersonales.minDias} días`
                                  }}
                                />
                          </Col>
                        </Col>
                      </Row>                  
                      <Row className="mb-5">
                          <div className="div-align-rigth">
                                <Button
                                    className="btn btn-primary"
                                    onClick={this.validateForm}
                                    style={{ display: "block", margin: "auto" }}
                                >
                                <i className="fa fa-chevron-circle-right" aria-hidden="true" /> {"CALCULAR"}
                                </Button>
                          </div>
                      </Row>
                      
                      <Row> 
                        <Col lg={12}md={12}sm={12}xs={12}>
                              <Button
                                  className="btn btn-detail-gray"
                                  onClick={() => this.setState({ selPlan: false, idPlan:"", numDias:""})}
                              >
                              <i className="fa fa-chevron-circle-left" aria-hidden="true" /> {"REGRESAR"}
                              </Button>  
                        </Col>   
                      </Row>
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            </Row>  
          </Col>
        }
        </Page>
        </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  datosCarritoAPTravelGroup : state.datosCarritoAPTravelGroup,
  datosCalculosCotizacionAP : state.datosCalculosCotizacionAP
});

const mapDispatchToProps = dispatch => {
  return {
    calculoCotizacion: datos => dispatch(fetchCalcularCotizacionAP(datos)),
    agregaProducto: datos => dispatch(fetchAgregarProductoCarritoAP(datos)),
    resetStateAP: () => dispatch(resetStateAP()),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionAPersonal2)
);
